/**
 * Un Excel binario viejo (`.xls`) convertido a CSV **en el navegador**, antes de subirlo.
 *
 * Covalto exporta su estado de cuenta en `.xls` (Excel 97-2003, formato binario OLE2), y la API solo
 * sabe abrir `.xlsx` y `.csv`. Convertirlo aquí evita meter en el servidor una dependencia nueva que
 * lea un formato binario de terceros: el panel ya depende de `xlsx` (SheetJS), que sí lo entiende.
 *
 * Se importa **bajo demanda**: SheetJS pesa cientos de kilobytes y solo lo necesita quien sube un
 * `.xls`. Cargarlo con el panel lo haría pagar a todas las pantallas.
 *
 *! Se toma la PRIMERA hoja y se escribe tal como se ve —`raw: false`—: fechas como «01 septiembre
 *! 2026» e importes como «$ 7,212,169.52». Es lo que el lector del servidor ya sabe interpretar;
 *! convertir a números aquí duplicaría esa lógica en dos repos.
 */
export async function xlsACsv(file: File): Promise<File> {
  const XLSX = await import('xlsx')
  const libro = XLSX.read(await file.arrayBuffer(), { type: 'array' })
  const hoja = libro.Sheets[libro.SheetNames[0]]
  if (!hoja) throw new Error('El archivo no tiene ninguna hoja')
  const csv = XLSX.utils.sheet_to_csv(hoja, { blankrows: false, rawNumbers: false })
  return new File([csv], file.name.replace(/\.xls$/i, '.csv'), { type: 'text/csv' })
}

/** ¿Es un `.xls` binario, que hay que convertir antes de subirlo? */
export function esXls(file: File): boolean {
  return /\.xls$/i.test(file.name)
}
